module.exports = __webpack_public_path__ + "img/raya.b9cdbc4f.jpg";